module.exports = __webpack_public_path__ + "static/img/icon_training_dark.446b462.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon_training_dark.png
// module id = 591
// module chunks = 1